import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { SessionService } from './session.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
  router = inject(Router);
  private oauthService = inject(OAuthService);
  private sessionService = inject(SessionService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.oauthService.tryLogin();
    if (this.oauthService.hasValidAccessToken()) {
      return this.sessionService.createSession().pipe(
        tap(result => {
          if (!result) {
            return false;
          } else {
            return result.success;
          }
        }))
    } else {
      return false;
    }
  }

}

